module.exports = __webpack_public_path__ + "img/plat_4882.42ddf22e.jpg";